import { Select, Skeleton } from "antd";
import { SeasonLabel } from "components/Shared/Labels/SeasonLabel";
import { useFetchSeasonsByEntityId } from "hooks/useSeasonsApi";
import { useNavigate, useParams } from "react-router-dom";

export const SeasonSelect = () => {
  const { customerId, sport, organizationId, seasonId: seasonIdFromParams, entityId: entityIdFromParams } = useParams();
  const entityId = entityIdFromParams || "undefined";
  const seasonId = seasonIdFromParams || "undefined";
  const { isLoading, data: seasonsResponse } = useFetchSeasonsByEntityId({
    entityId,
  });
  const seasons = seasonsResponse?.data || [];
  const season = seasons.filter((x: any) => seasonId === x?.seasonId)?.[0];
  const navigate = useNavigate();

  if (isLoading) {
    return <Skeleton.Input active={isLoading} />;
  }

  if (seasons && seasons.length === 0) {
    return "";
  }

  const onChangeHandler = (value) => {
    navigate(`${customerId}/${sport}/${organizationId}/entities/${entityId}/seasons/${value}/fixtures`);
  };

  return (
    <SeasonLabel
      imageUrl={season?.imageUrl}
      size={25}
      title={
        <Select
          popupMatchSelectWidth={false}
          variant="borderless"
          showSearch
          onChange={onChangeHandler}
          filterOption={(input, option) => `${option?.label ?? ""}`.toLowerCase().includes(input.toLowerCase())}
          optionRender={({ data: option }) => <SeasonLabel title={option?.label} imageUrl={option?.img} size={25} />}
          defaultValue={seasonId}
          loading={isLoading}
          options={seasons.map((x: any) => {
            return {
              label: x?.nameLocal,
              value: x?.seasonId,
              img: x?.imageUrl,
            };
          })}
        />
      }
    />
  );
};
